import { Component, inject } from '@angular/core';

import {
  extractHost,
  getDevBackendOverride
} from 'src/app/shared/functions/dev-backend-override.functions';
import { ModalService } from 'src/app/shared/services/modal/modal.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'axle-dev-backend-override',
  templateUrl: './axle-dev-backend-override.component.html'
})
export class AxleDevBackendOverrideComponent {
  private _modalService = inject(ModalService);

  hasOverride = !!getDevBackendOverride();
  shortLabel = shortLabelFor(extractHost(environment.backendLink));

  open() {
    if (this._modalService.hasOpenModal('dev_backend_override')) return;
    this._modalService.openModal('dev_backend_override');
  }
}

function shortLabelFor(host: string): string {
  const prMatch = host.match(
    /^api-([a-z0-9-]+)\.axle-be-api-pr\.axleaccess\.com$/
  );
  if (prMatch) return `pr-${prMatch[1]}`;

  const stdMatch = host.match(/^api-?([a-z0-9-]*)\.axleaccess\.com$/);
  if (stdMatch) return stdMatch[1] || 'axle';

  return host;
}
